import { render } from "./NewStudentForm.vue?vue&type=template&id=30a64ccc"
import script from "./NewStudentForm.vue?vue&type=script&lang=js"
export * from "./NewStudentForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__